import type { FC } from 'react';
import { Overlay } from '../Overlay/Overlay';
import { SystemButton } from '../SystemButton/SystemButton';
import { useScrolledContentState } from '../hooks/useScrolledContentState';
import { getDialogClassNames } from './Dialog.styles';
import type { DialogProps } from './Dialog.types';

export const Dialog: FC<DialogProps> = ({
  closeOnBackdropClick,
  size = 'default',
  header,
  children,
  footer,
  onClose,
  className,
}) => {
  const { scrollableContentRef, scrolledContentState } =
    useScrolledContentState();

  const dialogClassNames = getDialogClassNames({
    scrolledContentState,
    size,
    noFooter: !footer,
    className,
  });

  return (
    <Overlay
      alignment='center'
      onClose={closeOnBackdropClick ? onClose : undefined}
    >
      <div className={dialogClassNames.root}>
        <div className={dialogClassNames.container}>
          {header && (
            <div className={dialogClassNames.header}>
              <h3 className='text-level-3 font-semibold m-0 text-default'>
                {header.title}
              </h3>
              {!header.withoutCloseDecoration && (
                <SystemButton
                  icon='fa-close'
                  onClick={onClose}
                  size='large'
                  className='-m-r text-default'
                />
              )}
            </div>
          )}
          <div ref={scrollableContentRef} className={dialogClassNames.content}>
            {typeof children === 'function'
              ? children({
                  closeModal: () => {
                    onClose();
                  },
                })
              : children}
          </div>
          {footer && (
            <div className={dialogClassNames.footer}>
              {typeof footer === 'function'
                ? footer({
                    closeModal: () => {
                      onClose();
                    },
                  })
                : footer}
            </div>
          )}
        </div>
      </div>
    </Overlay>
  );
};
